export default class LocationFilter {
    constructor(transliterator, locationConfigStorage) {
        this.transliterator = transliterator;
        this.locationConfigStorage = locationConfigStorage;
    }

    filterMatchingLocations(filter) {
        return this.locationConfigStorage.getLocationConfig().locations
            .filter((location) => { return this.locationMatchesFilter(location, filter); });
    }

    locationMatchesFilter(location, filter) {
        let text = null;
        if (angular.isString(filter.text) && filter.text !== '') {
            text = this.transliterator.transliterate(filter.text).toLowerCase();
        }

        return ((
            !text
            || location.transliterated.title.indexOf(text) !== -1
            || location.transliterated.description.indexOf(text) !== -1
            || location.transliterated.address.indexOf(text) !== -1
        )
        && this.locationWithinBounds(location, filter.bounds)
        && (
            this.arrayIntersect(location.services, filter.services).length > 0
            || this.belongsToRootCategory(location.pay_categories, filter.payCategories)
        ));
    }

    belongsToRootCategory(subCategories, filteredRootCategories) {
        var rootCategories = [];
        angular.forEach(subCategories, (categoryId) => {
            angular.forEach(this.locationConfigStorage.getLocationConfig().pay_categories, (mainCategory) => {
                if (mainCategory.id === categoryId) {
                    if (mainCategory.hasOwnProperty('root_id')) {
                        rootCategories.push(mainCategory.root_id);
                    } else {
                        rootCategories.push(mainCategory.id);
                    }
                }
            })
        });

        var filteredRootCategoryIds = filteredRootCategories
            .map((rootCategory) => { return rootCategory.id; })
        ;

        return this.arrayIntersect(rootCategories, filteredRootCategoryIds).length > 0;
    }

    arrayIntersect(array1, array2) {
        return array1.filter((el) => { return array2.indexOf(el) !== -1; });
    }

    locationWithinBounds(location, bounds) {
        if (!bounds) {
            return true;
        }

        const lat = Number(location.lat);
        const lng = Number(location.lng);
        const south = Number(bounds.south);
        const north = Number(bounds.north);
        const west  = Number(bounds.west);
        const east  = Number(bounds.east);

        if (Number.isNaN(lat) || Number.isNaN(lng)) {
            return false;
        }

        if ([south, north, west, east].some(Number.isNaN)) {
            return false;
        }

        const withinLat = lat >= south && lat <= north;

        if (!withinLat) {
            return false;
        }

        if (west <= east) {
            return lng >= west && lng <= east;
        }

        return lng >= west || lng <= east;
    }

}

LocationFilter.$inject = ['transliterator', 'locationConfigStorage'];
